<template>
  <section class="top-tutors-list">
    <div class="mb-12">
      <BaseTitleSection :title="title" />
      <p class="top-tutors-list__subtitle">
        {{ subtitle }}
      </p>
      <CommonContinueRegistration btn-class="mx-auto mt-6 lg:w-[250px] w-[220px]">
        <template #else>
          <BaseButton
            shadow
            class="lg:w-[200px] w-[190px] mx-auto mt-6"
            size="md-lg"
            :label="$t('actions.become_tutor')"
            @click="$emit('signup')"
          />
        </template>
      </CommonContinueRegistration>
    </div>
    <div class="top-tutors-list__list">
      <div v-for="(item,key) in list" :key="key" class="top-tutors-list__item">
        <div class="lg:w-[140px] w-full flex lg:block justify-between">
          <BaseTeacherAvatar
            :id="item.username"
            :img-url="item.picture"
            :title="item.fullname"
            :subtitle="item.course"
            :size="{lg: '64', xs: '64'}"
            text-mode="below"
            class="justify-start lg:justify-center mb-4"
          />
          <BaseSeparator class="lg-block-hidden" />
          <BaseButton
            flat
            tag="a"
            :to="item.teacher_page"
            size="sm"
            :label="$t('common.actions.see_profile')"
            class="lg:mx-auto lg:mt-4 mt-8"
          />
        </div>
        <div class="lg:flex-1 w-full">
          <div class="text-overflow-dots max-w-[450px]">
            <span class="lg:text__body-2-md--bold text__caption-xs--bold text-label-text">
              {{ $t('labels.expertise') }}:
            </span>
            <span
              v-for="(el,key2) in item.teaching_courses"
              :key="el.id"
              class="text__caption-xs--bold lg:text__body-2-md--bold text-title"
            >{{ el.name }}<span v-if="key2 + 1 < item.teaching_courses.length">/</span></span>
          </div>
          <div class="mt-3">
            <p class="lg:text__body-3-md--bold text__body-2-xs--bold text-label-text">
              {{ $t('labels.about_me') }}:
            </p>
            <p
              v-if="item.teacher_about"
              class="text__caption-xs--regular lg:text__body-3-md--regular text-label-text"
              v-html="item.teacher_about.description"
            />
          </div>
        </div>
        <BaseSeparator class="lg-hidden-block my-3" />
        <div class="price-wrapper">
          <div class="pl-4 w-full text-center">
            <p class="text-title">
              <span class="text__body-1-md--bold flex items-center justify-center">
                <span>{{ currencySym(item.teaching_price.currency) }}</span>
                <span>{{ item.teaching_price.final_price }}</span>
              </span>
            </p>
            <p class="text__body-3-md--regular text-label-text">
              an hour
            </p>
          </div>
        </div>
      </div>
    </div>
    <BaseButton
      :label="label"
      color="primary"
      outline
      light
      class="mx-auto"
      size="xs"
      @click="showFullList = !showFullList"
    />
  </section>
</template>
<script>
import BaseTitleSection from '@design-system/base/title/title-section.vue'
import BaseTeacherAvatar from '@design-system/base/avatar/avatar-teacher.vue'
import { mapGetters } from 'vuex'
import { currencySymbol } from '@helper/currencySymbol'
import CommonContinueRegistration from '~/components/common/continue-registration.vue'

export default {
  name: 'TopTutorsList',
  components: { CommonContinueRegistration, BaseTeacherAvatar, BaseTitleSection },
  data () {
    return {
      title: 'List of top rated Ostado tutors',
      subtitle: 'Join us to become a top rated one!',
      showFullList: false
    }
  },
  computed: {
    ...mapGetters('global', ['getBestTeachers']),
    ...mapGetters('local', ['getStepStatus']),
    list () {
      return !this.showFullList ? this.getBestTeachers?.teachers.slice(0, 3) : this.getBestTeachers?.teachers
    },
    label () {
      return !this.showFullList ? 'Show more' : 'Show less'
    }
  },
  methods: {
    currencySym (currency) {
      return currencySymbol(currency)
    }
  }
}
</script>
<style scoped lang="scss">
.top-tutors-list {
  @apply container;
  &__subtitle {
    @apply text__body-1-md--regular text-body-2 text-center mt-4;
  }
  &__item {
    @apply flex flex-col lg:flex-row items-center p-4 lg:space-x-4 border border-primary-100
    rounded-2xl mb-4 relative max-w-[800px] mx-auto;
  }
  .price-wrapper {
    @screen lg {
      @apply  w-[100px] h-[206px] flex items-center border-l border-primary-100;
    }
  }
}
</style>
